/* Participants API — dispatches to the mock or the real HTTP backend. */
import { USE_MOCK_API } from './httpClient'
import * as mock from './participants.mock'
import * as http from './participants.http'

export type { InviteParticipantInput } from './participants.mock'

const impl = USE_MOCK_API ? mock : http

export const listParticipants = impl.listParticipants
export const inviteParticipant = impl.inviteParticipant
export const updateParticipant = impl.updateParticipant
export const removeParticipant = impl.removeParticipant
